import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Tooltip,
  TextField,
  Typography,
  DialogActions,
  Autocomplete,
} from '@mui/material'

import { HighlightOff as HighlightOffIcon, Delete as DeleteIcon } from '@mui/icons-material'
import { useEffect, useState } from 'react'

import _ from 'lodash'
import moment from 'moment'
import { DROPDOWN_DEFAULT_VALUE } from '../utils/autoCompute'
import { queryService } from '../../../services/queryService'
import { useAuthContext } from '../../../hooks/useAuthContext'

const QueryDialog = ({ processId, isQueryDialogOpen, setIsQueryDialogOpen }) => {
  const { user } = useAuthContext()
  const [newQueryQuestion, setNewQueryQuestion] = useState('')
  const [queries, setQueries] = useState([])
  const [allUsers, setAllUsers] = useState([])
  const [selectedQueryUser, setSelectedQueryUser] = useState(DROPDOWN_DEFAULT_VALUE)
  useEffect(() => {
    ;(async () => {
      const queryData = await queryService.getQuery(user, processId)

      setQueries(queryData.queries)
      setAllUsers(queryData.users)
      setNewQueryQuestion('')
      setSelectedQueryUser(DROPDOWN_DEFAULT_VALUE)
    })()
  }, [])

  const handleSaveQuery = async () => {
    if (selectedQueryUser == DROPDOWN_DEFAULT_VALUE) {
      return
    }
    await queryService.saveQuery(user, {
      process_id: processId,
      question_by: user.id,
      question: newQueryQuestion,
      answer_by: selectedQueryUser,
    })
    //refresh query data and reset query dropdown and query textarea
    const queryData = await queryService.getQuery(user, processId)
    setQueries(queryData.queries)
    setAllUsers(queryData.users)
    setNewQueryQuestion('')
    setSelectedQueryUser(DROPDOWN_DEFAULT_VALUE)
  }

  async function deleteQuery(queryId) {
    await queryService.deleteQuery(user, queryId)
    //refresh query data and reset query dropdown and query textarea
    const queryData = await queryService.getQuery(user, processId)
    setQueries(queryData.queries)
    setAllUsers(queryData.users)
    setNewQueryQuestion('')
    setSelectedQueryUser(DROPDOWN_DEFAULT_VALUE)
  }

  const handleSelectQueryUser = (_e, newValue) => {
    if (user?.id != newValue.id) {
      setSelectedQueryUser(newValue.id)
    } else {
      setSelectedQueryUser(DROPDOWN_DEFAULT_VALUE)
    }
  }

  return (
    <Dialog open={isQueryDialogOpen} fullWidth maxWidth="md">
      <DialogTitle>
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography className="textPrimary fontWeight700 fontsize20" variant="h5">
            Queries
          </Typography>
          <IconButton
            align="right"
            onClick={() => {
              setIsQueryDialogOpen(false)
              setSelectedQueryUser(DROPDOWN_DEFAULT_VALUE)
              setNewQueryQuestion('')
            }}
            size="small"
          >
            <HighlightOffIcon />
          </IconButton>
        </Grid>
      </DialogTitle>
      <DialogContent>
        {queries.map((q) => {
          const u = allUsers.find((au) => au.id === q.answer_by)

          return (
            <div key={q.id}>
              <Typography variant="body1">
                <strong>Q{q.id}</strong>
                {`. ${q.question} `}
                {q.is_open && (
                  <Tooltip title="Delete/retract query?">
                    <IconButton
                      size="small"
                      onClick={() => {
                        deleteQuery(q.id)
                      }}
                    >
                      <DeleteIcon size="small" />
                    </IconButton>
                  </Tooltip>
                )}
              </Typography>
              <Typography variant="body1">
                <strong>A</strong>
                {`. ${q.is_open ? 'Not answered yet.' : q.answer}`}
              </Typography>
              {u?.first_name && (
                <Typography sx={{ fontStyle: 'italic' }} variant="caption">
                  {`${u.first_name} ${u.last_name} (${u.email})`}
                  {!q.is_open &&
                    ` on ${moment(new Date(q.question_at)).format('DD MMM YYYY, hh:mm A')}`}
                </Typography>
              )}
              <br />
              <br />
            </div>
          )
        })}
        <TextField
          value={newQueryQuestion}
          fullWidth
          multiline
          size="small"
          variant="outlined"
          color="primary"
          label={'Enter query'}
          style={{ marginTop: '.7rem' }}
          minRows={3}
          onChange={(e) => setNewQueryQuestion(e.target.value)}
        />

        <Autocomplete
          options={allUsers || []}
          getOptionLabel={(option) => `${option.first_name} ${option.last_name} (${option.email})`}
          value={allUsers?.filter((user) => user.id == selectedQueryUser)[0] || null}
          fullWidth
          style={{ marginTop: '.5rem' }}
          onChange={(e, newValue) => {
            handleSelectQueryUser(e, newValue)
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              color="primary"
              size="small"
              label={'Select User to Answer Query'}
            />
          )}
        />
        <DialogActions>
          <Button
            autoFocus
            variant="outlined"
            color="primary"
            onClick={() => {
              setIsQueryDialogOpen(false)
              setSelectedQueryUser(DROPDOWN_DEFAULT_VALUE)
              setNewQueryQuestion('')
            }}
          >
            Cancel
          </Button>

          <Button className="primary-btn" color="info" variant="outlined" onClick={handleSaveQuery}>
            Add New Query
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  )
}

export default QueryDialog
